import { useNavigate } from 'react-router'
import { useNotifications } from '~/hooks/useNotifications'
import { ApplicationRoutes } from '~/hooks/useRouting'
import { useWebSocketService } from '~/hooks/useWebSocketService'
import { WebSocketEventType } from '~/types'
import { useMessageGroupsViewModel } from '~/viewModels/Messaging/MessageGroupsViewModel'
import { useMessageThreadsViewModel } from '~/viewModels/Messaging/MessageThreadsViewModel'

const WSS_MSG_RECEIVED_SUBSCRIPTION_TOKEN = 'useMessageReceivedNotifications'
export const useMessageReceivedNotifications = (navigateOnClick = true) => {
  const { sendNotification } = useNotifications()
  const { subscribe: wssSubscribe } = useWebSocketService()
  const { selectedThread } = useMessageThreadsViewModel()
  const { userMessageGroups } = useMessageGroupsViewModel()
  const navigate = useNavigate()

  wssSubscribe(WebSocketEventType.MessageReceived, {
    subscriptionToken: WSS_MSG_RECEIVED_SUBSCRIPTION_TOKEN,
    callback: (message) => {
      const groupId = message.payload.group?.id
      const isPartOfUserGroup = userMessageGroups?.some(
        (mg) => mg.id === groupId,
      )

      if (!isPartOfUserGroup) {
        return
      }

      const threadId = message.payload.threadId
      const isThreadSelected = threadId === selectedThread?.id
      if (isThreadSelected) {
        return
      }

      sendNotification({
        title: 'New message received!',
        body: message.payload.text,
        onClick: () => {
          if (navigateOnClick) {
            navigate(
              `${ApplicationRoutes.MESSAGING}?threadId=${message.payload.threadId}`,
            )
          }
        },
      })
    },
  })
}
